import { DynamicDocumentItem, DynamicDocumentItemData } from '@/types';

export function difference<T extends Record<string, any>>(a: T, b: T): Partial<T> {
  return Object.keys(a).reduce((diff, key) => {
    if (b[key] !== a[key]) {
      diff[key] = a[key];
    }

    return diff;
  }, {} as any);
}

/**
 * The uploaded-image URLs a document item points at: an IMAGE holds an array of
 * URLs, a SIGNATURE holds `[payload, url]`, everything else has none. Mirrors the
 * extraction in InstallationModule.images() so per-field/section warnings and the
 * module-level "missing on server" banner always agree on which photos count.
 */
export function imageUrlsForItem(
  item: DynamicDocumentItem,
  data?: DynamicDocumentItemData
): string[] {
  const value = data?.value;
  if (item.type === 'IMAGE' && Array.isArray(value)) return value as string[];
  if (item.type === 'SIGNATURE' && Array.isArray(value) && value[1]) return [value[1] as string];

  return [];
}

export { isItemRequired } from './required';
